import React, { useState, useEffect } from 'react'
import { Form, Select, Radio } from 'antd'
import styled from 'styled-components'
import { t } from '@/i18n'
import { BasSwitch } from '@/components'

const AutoReportConfig: React.FC<{ dataOptions: any }> = ({ dataOptions }) => {
  const [send, setSend] = useState(false)
  const [filter, setFilter] = useState(false)
  const form = Form.useFormInstance()

  // 同步表单值与本地状态
  useEffect(() => {
    const reportConfig = form.getFieldValue('reportConfig')
    if (reportConfig) {
      setSend(reportConfig.send || false)
      setFilter(reportConfig.filter || false)
    }
  }, [form])

  return (
    <Wrapper>
      <div className="section-title">
        {t('任务高级配置')}
        <div className="section-bar" />
      </div>
      {/* 自动发送报表 */}
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          marginBottom: 24,
          paddingLeft: 34,
        }}
      >
        <Form.Item
          label={
            <div className="custom-label">
              <span>{t('发送报表')}</span>
            </div>
          }
          name={['reportConfig', 'send']}
          valuePropName="checked"
          style={{ marginBottom: 0, marginRight: 24 }}
        >
          <BasSwitch
            checked={send}
            onChange={checked => {
              setSend(checked)
              form.setFieldValue(['reportConfig', 'send'], checked)
            }}
            style={{ marginLeft: 8 }}
          />
        </Form.Item>
        {send && (
          <>
            <span style={{ color: '#666', marginRight: 12 }}>{t('发送邮箱')}</span>
            <Form.Item
              name={['reportConfig', 'emailIds']}
              style={{ marginBottom: 0, width: 360 }}
              rules={[{ required: true, message: t('请选择发送邮箱') }]}
            >
              <Select
                mode="multiple"
                maxTagCount={1}
                showSearch
                showArrow
                placeholder={t('人员名称/邮箱地址')}
                style={{ width: 360 }}
                options={dataOptions.emailOptions}
              />
            </Form.Item>
          </>
        )}
      </div>
      {/* 报表发送过滤 */}
      {send && (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            paddingLeft: 34,
          }}
        >
          <Form.Item
            label={
              <div className="custom-label">
                <span>{t('过滤配置')}</span>
              </div>
            }
            name={['reportConfig', 'filter']}
            valuePropName="checked"
            style={{ marginBottom: 0, marginRight: 24 }}
          >
            <BasSwitch
              checked={filter}
              onChange={checked => {
                setFilter(checked)
                form.setFieldValue(['reportConfig', 'filter'], checked)
              }}
              style={{ marginLeft: 8 }}
            />
          </Form.Item>
          {filter && (
            <>
              <span style={{ color: '#666', marginRight: 12 }}>{t('过滤条件')}</span>
              <Form.Item
                name={['reportConfig', 'condition']}
                style={{ marginBottom: 0 }}
                rules={[{ required: true, message: t('请选择过滤条件') }]}
              >
                <Radio.Group className="radio-group">
                  <Radio value="conditionExistFailed">{t('任意用例防护失效')}</Radio>
                  <Radio value="conditionAllFailed">{t('全部用例防护失效')}</Radio>
                </Radio.Group>
              </Form.Item>
            </>
          )}
        </div>
      )}
    </Wrapper>
  )
}

export default AutoReportConfig

const Wrapper = styled.div`
  margin-bottom: 16px;

  .section-title {
    font-weight: 500;
    color: #1d2129;
    position: relative;

    &::after {
      content: '';
      display: block;
      position: absolute;
      left: 0;
      bottom: 0;
      width: 88px;
      height: 6px;
      background: linear-gradient(90deg, #2090a8 0%, #4238c9 100%);
      border-radius: 0px 86px 0px 100px;
      margin-top: 8px;
    }

    .section-bar {
      content: '';
      display: block;
      width: 100%;
      height: 4px;
      background: #ebeaf9;
      margin-top: 4px;
      margin-bottom: 20px;
    }
  }

  .radio-group {
    display: flex;
    align-items: center;

    .ant-radio-wrapper {
      margin-bottom: 0;
      margin-right: 60px;
    }

    .ant-radio-wrapper span:last-child {
      line-height: 32px;
    }
  }
`
